export const SITUACAO_MATRICULA = {
  // SITUACAO DE MATRICULA DO SISTEMA ESCOLAR

  0: "PENDENTE", // ---------------- ALUNO ESPERANDO MATRÍCULA SER RENOVADA NA 1º FASE DE MATRÍCULA
  1: "ATIVA", // ------------------- ALUNO ESTUDANDO
  2: "EM TRANSFERÊNCIA", // -------- ALUNO SOLICITOU TRANSFERÊNCIA E ESTÁ AGUARDANDO OUTRA ESCOLA CAPTURÁ-LO
  3: "FECHADA (OCULTADA)", // ------ MATRÍCULA FECHADA (NÃO APARECE NA LISTAGEM)
  4: "CONCLUÍDA", // --------------- ALUNO CONCLUIU O PERÍODO LETIVO EM QUESTÃO
  5: "CANCELADO", // --------------- MATRÍCULA CANCELADA POR MOTIVOS DE ERRO (APARECE NAS LISTAGENS)
  6: "INATIVO", // ----------------- MATRÍCULA INATIVADA NÃO APARECE NAS LISTAGENS
  7: "TRANSFERIDO", // ------------- QUANDO UMA NOVA MATRÍCULA É ATIVADA APÓS TRANSFERÊNCIA. A ANTERIOR FICA COM O STATUS TRANSFERIDO
  8: "RECLASSIFICADO", // ---------- ALUNO É MATRICULADO EM UMA CURSO DIFERENTE APÓS ANÁLISE E PERMISSÃO DA SMED
  9: "REALOCADO", // --------------- ALUNO É MATRICULADO EM UMA NOVA CURSO OU TURMA PARA CORREÇÃO NO SISTEMA
  10: "EVADIDO", // ---------------- ALUNO SE EVADIU ANTES DO TÉRMINO DO ANO LETIVO
  11: "DESISTENTE", //-------------- ALUNO DESISTIU ANTES DO TÉMINO DO ANO LETIVO
  12: "FECHADA", //----------------- MATRÍCULA FECHADA (APARECE NA LISTAGEM)
  13: "RENOVADA",
  14: "NÃO CONCLUÍDO",
  15: "AGENDADO",

  // 0: 'ATIVA', ------------------- SITUAÇÃO_MATRICULA: ATIVA
  // 1: 'CONCLUIDA', --------------- SITUAÇÃO_MATRICULA: CONCLUIDA + FECHADA
  // 2: 'TRANCADA', ---------------- REMOVIDA
  // 3: 'CANCELADO', --------------- SITUAÇÃO_MATRICULA: CANCELAD0
  // 4: 'PENDENTE', ---------------- SITUAÇÃO_MATRICULA: PENDENTE
  // 5: 'EM_TRANSFERENCIA', -------- SITUAÇÃO_MATRICULA: EM_TRANSFERÊNCIA
  // 6: 'TRANSFERIDO', ------------- SITUAÇÃO_MATRICULA: TRANSFERIDO
  // 7: 'EVADIDO', ----------------- SITUACAO_ACADEMICA: EVADIDO
  // 8: 'INATIVO', ----------------- SITUAÇÃO_MATRICULA: INATIVO
  // 9: 'DESISTENTE', -------------- SITUACAO_ACADEMICA: DESISTENTE
  // 10: 'RECLASSIFICACA', --------- SITUAÇÃO_MATRICULA: RECLASSIFICADA
  // 11: 'REALOCACAO', ------------- SITUAÇÃO_MATRICULA: REALOCACAO
  // 12: 'FALECIDO', --------------- SITUACAO_ACADEMICA: FALECIDO
  // 13: 'FECHADA' ----------------- REMOVIDA
};

export const SITUACAO_ACADEMICA = {
  // SITUAÇÃO ACADEMICA DO SISTEMA ESCOLAR

  0: "ABERTO", // ------------------ CURSANDO AINDA NÃO SE SABE SE O ALUNO FOI APROVADO, CONSERVADO ETC
  1: "APROVADO", // ---------------- ALUNO OBTEVE NOTA ACIMA DE MÉDIA ANUAL E FOI APROVADO
  2: "CONSERVADO", // -------------- ALUNO NÃO OBTEVE A MÉDIA ANUAL NECESSÁRIA PARA A SUA APROVAÇÃO
  3: "EVADIDO", //------------------ ALUNO PAROU DE FREQUENTAR A INSTITUIÇÃO E A INSTITUIÇÃO NÃO SABE O MOTIVO
  4: "DESISTENTE", // -------------- ALUNO PAROU DE FREQUENTAR A INSTITUIÇÃO E A INSTITUIÇÃO FOI COMUNICADA SOBRE O MOTIVO
  5: "FALECIDO", // ---------------- ALUNO FALECEU
  6: "TRANSFERIDO", // ------------- ALUNO SAIU DA INSTITUIÇÃO ANTES DO TÉRMINO
};

export const TIPO_USER = {
  0: "SECRETÁRIO ESCOLAR",
  1: "DIRETOR ESCOLAR",
  2: "PROFESSOR",
  3: "COORDENADOR PEDAGÓGICO",
  4: "NTI - PMVC",
  5: "NTI - SMED",
  6: "SMED - LEGALIZAÇÃO",
  7: "SMED - PEDAGÓGICO",
  8: "SMED - RECURSOS HUMANOS",
  9: "SMED - TABULAÇÃO",
  10: "CONSULTA",
  12: "VICE-DIRETOR",
};

export const LOCALIZACAO_ZONA = {
  1: "URBANA",
  2: "RURAL",
};

export const SITUACAO_FUNCIONAMENTO = {
  1: "EM ATIVIDADE",
  2: "PARALISADA",
  3: "EXTINTA",
};

export const SEXO = {
  0: "MASCULINO",
  1: "FEMININO",
};

export const RACA_COR = {
  0: "NÃO DECLARADA",
  1: "BRANCA",
  2: "PRETA",
  3: "PARDA",
  4: "AMARELA",
  5: "INDÍGENA",
};

export const TURNO = {
  0: "MATUTINO",
  1: "VESPERTINO",
  2: "NOTURNO",
  4: "INTEGRAL", //O EDF PULOU O NÚMERO 3. A IMPORTAÇÃO MANTEVE A ORDEM.
};

export const SITUACAO_TURMA = {
  0: "CONCLUIDO",
  1: "ATIVO",
  2: "PENDENTE",
  3: "INATIVO",
};

export const TIPO_ENSINO = {
  1: "ENSINO REGULAR",
  2: "EJA",
  3: "EDUCAÇÃO ESPECIAL",
  4: "ATIVIDADE COMPLEMENTAR",
  5: "PROJOVEM",
};

export const CONTEXTO_FREQUENCIA = {
  "PRINCIPAL": "PRINCIPAL",
  "AEE": "AEE",
  "ATIVIDADE_COMPLEMENTAR": "ATIVIDADE_COMPLEMENTAR"
};

export const ETAPA = {
  0: "EDUCAÇÃO INFANTIL",
  1: "FUNDAMENTAL I",
  2: "FUNDAMENTAL II",
};

export const CURSO_NACIONAL = {
  1: "CRECHE 1 ANO",
  2: "CRECHE 2 ANOS",
  3: "CRECHE 3 ANOS",
  4: "EDUCAÇÃO INFANTIL - 04 ANOS",
  5: "EDUCAÇÃO INFANTIL - 05 ANOS",
  6: "1º ANO",
  7: "2º ANO",
  8: "3º ANO",
  9: "4º ANO",
  10: "5º ANO",
  11: "6º ANO",
  12: "7º ANO",
  13: "8º ANO",
  14: "9º ANO",
};

export const TIPO_SERVIDOR = {
  1: "DIRETOR",
  2: "COORDENADOR PEDAGÓGICO",
  3: "PROFESSOR",
};

export const CARGO_SERVIDOR = {
  1: "CARGO 1",
  2: "CARGO 2",
  3: "CARGO 3",
  4: "CARGO 4",
};

export const FUNCAO_SERVIDOR = {
  1: "DOCENTE",
  2: "AUXILIAR/ASSISTENTE EDUCACIONAL",
  3: "PROFISSIONAL/MONITOR DE ATIVIDADE  COMPLEMENTAR",
  4: "TRADUTOR E INTERPRETE DE LIBRAS",
  // 5: 'DOCENTE TITULAR - COORDENADOR DE TUTORIA (DE  MÓDULO OU DISCIPLINA) - EAD',
  // 6: 'DOCENTE TUTOR - AUXILIAR (DE MÓDULO OU DISCIPLINA) - EAD',
  7: "GUIA-INTERPRETE",
  8: "PROFISSIONAL DE APOIO ESCOLAR PARA ALUNO(A)S COM DEFICIENCIA (LEI 13.146/2015)",
  9: "SECRETARIO ESCOLAR",
  10: "AUXILIAR DE SECRETARIA",
  11: "DIRETOR",
  12: "VICE-DIRETOR",
  13: "COORDENADOR PEDAGÓGICO",
  14: "PEDAGOGO",
};

export const SITUACAO_FUNCIONAL_SERVIDOR = {
  1: "CONCURSADO/EFETIVO/ESTAVEL",
  2: "CONTRATO TEMPORARIO",
  3: "CONTRATO TERCEIRIZADO",
  4: "CONTRATO CLT",
};

export const MAIOR_ESCOLARIDADE_SERVIDOR = {
  1: "NÃO CONCLUIU O ENSINO FUNDAMENTAL",
  2: "ENSINO FUNDAMENTAL",
  7: "ENSINO MÉDIO",
  6: "EDUCAÇÃO SUPERIOR",
};

export const TIPO_ENSINO_MEDIO_SERVIDOR = {
  1: "FORMAÇÃO GERAL",
  2: "MODALIDADE NORMAL (MAGISTÉRIO)",
  3: "CURSO TÉCNICO",
  4: "MAGISTÉRIO INDÍGENA - MODALIDADE NORMAL",
};

export const POS_GRADUACAO_SERVIDOR = {
  "1": "ESPECIALIZACAO",
  "2": "MESTRADO",
  "3": "DOUTORADO",
};

export const AREA_POS_GRADUACAO_SERVIDOR = {
  99: "PROGRAMAS BÁSICOS",
  1: "EDUCAÇÃO",
  2: "ARTES E HUMANIDADES",
  3: "CIÊNCIAS SOCIAIS, COMUNICAÇÃO E INFORMAÇÃO",
  4: "NEGÓCIOS, ADMINISTRAÇÃO E DIREITO",
  5: "CIÊNCIAS NATURAIS, MATEMÁTICA E ESTATÍSTICA",
  6: "COMPUTAÇÃO E TECNOLOGIAS DA INFORMAÇÃO E COMUNICAÇÃO (TIC)",
  7: "ENGENHARIA, PRODUÇÃO E CONSTRUÇÃO",
  8: "AGRICULTURA, SILVICULTURA, PESCA E VETERINÁRIA",
  9: "SAÚDE E BEM-ESTAR",
  10: "SERVIÇOS",
};

export const SALA_LOCAL_DIFERENCIADO = {
  0: "NÃO",
  1: "SALA ANEXA",
  2: "UNIDADE DE ATENDIMENTO SOCIOEDUCATIVO",
  3: "UNIDADE PRISIONAL",
};

export const HISTORICO_PENDENTE = {
  0: "FALTANDO",
  1: "CONFECCIONAR",
  2: "RECEBIDO",
  3: "ENTREGUE",
};

/****** CONSTANTES EDUCACENSO ******/

export const LOCALIZACAO_DIFERENCIADA_ESCOLA = {
  1: "ÁREA DE ASSENTAMENTO",
  2: "TERRA INDÍGENA",
  3: "COMUNIDADE QUILOMBOLA",
  7: "NÃO ESTÁ EM ÁREA DE LOCALIZAÇÃO DIFERENCIADA",
  8: "ÁREA ONDE SE LOCALIZAM POVOS E COMUNIDADES TRADICIONAIS",
};

export const DEPENDENCIA_ADMINISTRATIVA = {
  1: "FEDERAL",
  2: "ESTADUAL",
  3: "MUNICIPAL",
  4: "PRIVADA",
};

export const REGULAMENTACAO_AUTORIZACAO = {
  0: "NÃO",
  1: "SIM",
  2: "EM TRAMITAÇÃO",
};

export const FORMA_OCUPACAO_PREDIO = {
  1: "PRÓPRIO",
  2: "ALUGADO",
  3: "CEDIDO",
};

export const RELATORIO_ALUNO_AGRUPAMENTO = {
  instituicao: "Instituição",
  turma: "Turma",
  curso: "curso",
  bairro: "Bairro",
};

export const STATUS_PRE_MATRICULA = {
  1: "PROCESSANDO",
  2: "ATIVO",
  3: "CANCELADO",
  4: "FINALIZADO",
};

export const STATUS_SUPORTE = {
  1: "EM ABERTO",
  2: "EM ANÁLISE",
  3: "FINALIZADO",
};

export const STATUS_EDUCACENSO = {
  1: "PENDENTE",
  2: "ARQUIVO GERADO",
  4: "MIGRADO",
  5: "FECHADO",
};


export const NOME_MES = (ref) => {
  
  let data = ref.split("-")
  
  switch (data[0]) {
    case '01': return "JANEIRO - " + data[1];
    case '02': return "FEVEREIRO - " + data[1];
    case '03': return "MARÇO - " + data[1];
    case '04': return "ABRIL - " + data[1];
    case '05': return "MAIO - " + data[1];
    case '06': return "JUNHO - " + data[1];
    case '07': return "JULHO - " + data[1];
    case '08': return "AGOSTO - " + data[1];
    case '09': return "SETEMBRO - " + data[1];
    case '10': return "OUTUBRO - " + data[1];
    case '11': return "NOVEMBRO - " + data[1];
    case '12': return "DEZEMBRO - " + data[1];
    default:
      return ref;
  }

};

export const FASE_DIARIO = {
  1: "-",
  2: "CONSELHO PARCIAL",
  3: "CONSELHO PARCIAL ENCERRADO",
  4: "CONSELHO FINAL",
  5: "FECHADO",
};

export const DIARIO_ORDEM_DISCIPLINAS = [
  36, //LÍNGUA/LITERATURA PORTUGUESA
  33, //MATEMÁTICA
  35, //CIÊNCIAS
  42, //HISTÓRIA
  43, //GEOGRAFIA
  37, //LÍNGUA/LITERATURA ESTRANGEIRA – INGLÊS
  41, //EDUCAÇÃO FÍSICA
  40, //ARTE (EDUCAÇÃO ARTÍSTICA, TEATRO, DANÇA, MÚSICA, ARTES PLÁSTICAS E OUTRAS)
  49, //ENSINO RELIGIOSO
  6,  //HISTÓRIA E CULTURA AFRO
  14, //EDUCACAO AMBIENTAL
  7   //TECNICAS AGRICOLAS
];

export const DIARIO_DISCIPLINAS_NAO_REPROVAM = [
  49, //ENSINO RELIGIOSO
  41, //EDUCAÇÃO FÍSICA
  40, //ARTE (EDUCAÇÃO ARTÍSTICA, TEATRO, DANÇA, MÚSICA, ARTES PLÁSTICAS E OUTRAS)
  14, //EDUCACAO AMBIENTAL
  7,  //TECNICAS AGRICOLAS
  6,  //HISTÓRIA E CULTURA AFRO
];

export const FLAGS_DIARIO = {
  ACP: 'APROVADO PELO CONSELHO PARCIAL',
  ACF: 'APROVADO PELO CONSELHO FINAL',
  AP: 'APROXIMADO AUTOMATICAMENTE'
};

export const MEDIA = 5;

export const TIPOS_DEFICIENCIA = {
  1: "CEGUEIRA",
  2: "BAIXA VISÃO",
  3: "SURDEZ",
  4: "DEFICIÊNCIA AUDITIVA",
  5: "SURDOCEGUEIRA",
  6: "DEFICIÊNCIA FÍSICA",
  7: "DEFICIÊNCIA INTELECTUAL",
  8: "DEFICIÊNCIA MÚLTIPLA",
  10: "SÍNDROME DE ASPERGER",
  11: "SÍNDROME DE RETT",
  12: "TRANSTORNO DESINTEGRATIVO",
  13: "SUPERDOTAÇÃO",
  14: "TRANSTORNO DO ESPECTRO AUTISTA",
  15: "SÍNDROME DE DOWN",
  16: "VISÃO MONOCULAR",
};

// ============================================================
// PEDAGÓGICO — PAEE / AEE / PDI
// Listas usadas como checkboxes/selects nos formulários de plano. O `v` é a
// chave estável armazenada no JSON `dados`; o `l` é o rótulo de exibição.
// ============================================================

export const PAEE_LOCAIS = [
  { v: 'sala_recurso', l: 'Sala de Recurso - SRM' },
  { v: 'outro', l: 'Outro' },
];

export const PAEE_PROFISSIONAIS = [
  { v: 'psicologo', l: 'Psicólogo' },
  { v: 'fonoaudiologo', l: 'Fonoaudiólogo' },
  { v: 'neurologista', l: 'Neurologista' },
  { v: 'terapia_ocupacional', l: 'Terapia Ocupacional' },
  { v: 'musicalizacao', l: 'Musicalização' },
  { v: 'psiquiatra', l: 'Psiquiatra' },
  { v: 'outro', l: 'Outro' },
];

export const PAEE_RESPONSAVEIS = [
  { v: 'mae', l: 'Mãe' },
  { v: 'pai', l: 'Pai' },
  { v: 'outro', l: 'Outro' },
];

export const PAEE_TIPOS_ATENDIMENTO = [
  { v: 'individual', l: 'Individual' },
  { v: 'dupla', l: 'Em dupla' },
  { v: 'trio', l: 'Em trio' },
  { v: 'colaborativo', l: 'AEE colaborativo' },
  { v: 'outros', l: 'Outros' },
];

export const PAEE_FREQUENCIAS = [
  { v: '1x', l: '1x/semana' },
  { v: '2x', l: '2x/semana' },
  { v: 'outro', l: 'Outro' },
];

export const PAEE_DURACOES = [
  { v: '50min', l: '50 min/atendimento' },
  { v: 'outro', l: 'Outro' },
];

export const PAEE_AREAS = [
  { v: 'motor', l: 'Desenvolvimento Motor' },
  { v: 'linguagem', l: 'Linguagem e Comunicação' },
  { v: 'cognicao', l: 'Cognição' },
  { v: 'autocuidados', l: 'Autocuidados' },
  { v: 'socializacao', l: 'Socialização, Interação e Desenvolvimento Emocional' },
];

export const PAEE_FORMA_COMUNICACAO = [
  { v: 'oral', l: 'Oral' },
  { v: 'alternativa', l: 'Comunicação alternativa' },
  { v: 'libras', l: 'Libras' },
  { v: 'gestos', l: 'Gestos' },
  { v: 'gritos_choros', l: 'Gritos e choros' },
  { v: 'palavras_compreensiveis', l: 'Palavras compreensíveis' },
  { v: 'palavra_frase', l: 'Palavra-frase' },
  { v: 'aponta', l: 'Aponta' },
  { v: 'braile', l: 'Braile' },
  { v: 'outras', l: 'Outras formas' },
];

export const PAEE_QUEM_ENTENDE = [
  { v: 'familia', l: 'Só a família' },
  { v: 'todos', l: 'Todos entendem' },
  { v: 'professor', l: 'Professor/Auxiliar de inclusão' },
  { v: 'ninguem', l: 'Ninguém entende' },
  { v: 'outros', l: 'Outros' },
];

export const AEE_DIAS_SEMANA = [
  { v: 'seg', l: 'Segunda' },
  { v: 'ter', l: 'Terça' },
  { v: 'qua', l: 'Quarta' },
  { v: 'qui', l: 'Quinta' },
  { v: 'sex', l: 'Sexta' },
];

export const AEE_MODALIDADES = [
  { v: 'individual', l: 'Individual' },
  { v: 'coletivo', l: 'Coletivo' },
];

export const AEE_POTENCIALIDADES = [
  { v: 'funcoes_executivas', l: 'Funções executivas' },
  { v: 'atencao_percepcao', l: 'Atenção/percepção/organização/memorização' },
  { v: 'motricidade_ampla', l: 'Motricidade ampla' },
  { v: 'motricidade_fina', l: 'Motricidade fina' },
  { v: 'oralidade', l: 'Oralidade' },
  { v: 'criatividade', l: 'Criatividade' },
  { v: 'autonomia', l: 'Autonomia' },
  { v: 'matematica', l: 'Linguagem Matemática' },
  { v: 'sociabilidade', l: 'Sociabilidade' },
  { v: 'estimulacao_sensorial', l: 'Estimulação sensorial' },
  { v: 'afetividade', l: 'Afetividade' },
  { v: 'interacao', l: 'Interação' },
  { v: 'artistica', l: 'Linguagem artística' },
  { v: 'visual', l: 'Linguagem visual' },
  { v: 'receptiva', l: 'Linguagem receptiva/funcional' },
  { v: 'outros', l: 'Outros' },
];

export const AEE_ESTRATEGIAS = [
  { v: 'acolhida', l: 'Acolhida' },
  { v: 'leitura_professor', l: 'Leitura pelo professor' },
  { v: 'musica', l: 'Música' },
  { v: 'contacao_historia', l: 'Contação de história' },
  { v: 'reconto', l: 'Reconto' },
  { v: 'escrita', l: 'Escrita' },
  { v: 'dobradura', l: 'Dobradura' },
  { v: 'videos', l: 'Vídeos' },
  { v: 'desenho', l: 'Desenho' },
  { v: 'pintura', l: 'Pintura' },
  { v: 'recorte', l: 'Recorte' },
  { v: 'colagem', l: 'Colagem' },
  { v: 'modelagem', l: 'Modelagem' },
  { v: 'rasgadura', l: 'Rasgadura' },
  { v: 'jogos', l: 'Jogos' },
  { v: 'painel_sensorial', l: 'Painel sensorial' },
  { v: 'software', l: 'Atividades de software' },
  { v: 'tecnologia_assistiva', l: 'Tecnologia assistiva' },
  { v: 'dramatizacao', l: 'Dramatização' },
  { v: 'avd', l: "AVD's" },
  { v: 'brincadeiras', l: 'Brincadeiras' },
  { v: 'outros', l: 'Outros' },
];

export const AEE_CATEGORIAS = {
  texturas: [
    { v: 'mole', l: 'Mole' }, { v: 'dura', l: 'Dura' }, { v: 'lisa', l: 'Lisa' },
    { v: 'macia', l: 'Macia' }, { v: 'aspera', l: 'Áspera' }, { v: 'liquida', l: 'Líquida' },
    { v: 'outros', l: 'Outros' },
  ],
  avd: [
    { v: 'higiene', l: 'Higiene pessoal' }, { v: 'vestir', l: 'Vestir-se' },
    { v: 'alimentar', l: 'Alimentar-se' }, { v: 'compras', l: 'Fazer compras' },
    { v: 'organizar', l: 'Limpar e organizar' },
    { v: 'outros', l: 'Outros' },
  ],
  jogos: [
    { v: 'montar', l: 'Montar' }, { v: 'empilhar', l: 'Empilhar' },
    { v: 'obstaculos', l: 'Obstáculos' }, { v: 'memoria', l: 'Memória' },
    { v: 'encaixe', l: 'Encaixe' }, { v: 'caca_palavras', l: 'Caça-palavras' },
    { v: 'numeros', l: 'Números e quantidades' }, { v: 'interativos', l: 'Interativos' },
    { v: 'outros', l: 'Outros' },
  ],
  motricidade_fina: [
    { v: 'escrever', l: 'Escrever' }, { v: 'desenhar', l: 'Desenhar' },
    { v: 'pintar', l: 'Pintar' }, { v: 'colar', l: 'Colar' },
    { v: 'amassar', l: 'Amassar' }, { v: 'rasgar', l: 'Rasgar' },
    { v: 'recortar', l: 'Recortar' }, { v: 'alinhavar', l: 'Alinhavar' },
    { v: 'abotoar', l: 'Abotoar' }, { v: 'separar_graos', l: 'Separar grãos' },
    { v: 'empilhar_mf', l: 'Empilhar' }, { v: 'modelar', l: 'Modelar' },
    { v: 'abrir_fechar', l: 'Abrir/Fechar' },
    { v: 'outros', l: 'Outros' },
  ],
  motricidade_ampla: [
    { v: 'correr', l: 'Correr' }, { v: 'pular', l: 'Pular' },
    { v: 'subir', l: 'Subir' }, { v: 'descer', l: 'Descer' },
    { v: 'arremessar', l: 'Arremessar' }, { v: 'mexer', l: 'Mexer membros' },
    { v: 'dancar', l: 'Dançar' }, { v: 'saltar', l: 'Saltar' },
    { v: 'andar', l: 'Andar' }, { v: 'andar_linhas', l: 'Andar sobre linhas' },
    { v: 'empurrar', l: 'Empurrar' }, { v: 'direita', l: 'Direita' },
    { v: 'esquerda', l: 'Esquerda' },
    { v: 'outros', l: 'Outros' },
  ],
  pintura: [
    { v: 'dedo', l: 'Dedo' }, { v: 'rolo', l: 'Rolo' },
    { v: 'esponja', l: 'Esponja' }, { v: 'plastico', l: 'Saco plástico' },
    { v: 'canudo', l: 'Canudo' }, { v: 'pente', l: 'Pente' },
    { v: 'carimbos', l: 'Carimbos' }, { v: 'pincel', l: 'Pincel' },
    { v: 'cotonete', l: 'Cotonete' }, { v: 'algodao', l: 'Algodão' },
    { v: 'garfo', l: 'Garfo' }, { v: 'folhas', l: 'Folhas' },
    { v: 'outros', l: 'Outros' },
  ],
};

export const AEE_RECURSOS = {
  tecnologia: [
    { v: 'acessibilidade_pc', l: 'Acessibilidade ao computador' },
    { v: 'app_caa', l: 'Apps CAA' },
    { v: 'notebook', l: 'Notebook' },
    { v: 'celular', l: 'Celular' },
    { v: 'tablet', l: 'Tablet' },
    { v: 'caixa_som', l: 'Caixa de som' },
    { v: 'microfone', l: 'Microfone' },
    { v: 'computador', l: 'Computador' },
    { v: 'outros', l: 'Outros' },
  ],
  diversos: [
    { v: 'tesoura', l: 'Tesoura (comum/adaptada)' },
    { v: 'caixa_areia', l: 'Caixa mágica/de areia' },
    { v: 'tinta', l: 'Tinta' }, { v: 'palitos', l: 'Palitos' },
    { v: 'livros', l: 'Livros' }, { v: 'alfabeto', l: 'Alfabeto móvel' },
    { v: 'numeros', l: 'Números' }, { v: 'reciclavel', l: 'Material reciclável' },
    { v: 'instrumentos', l: 'Instrumentos musicais' }, { v: 'eva', l: 'EVA' },
    { v: 'micangas', l: 'Miçangas' }, { v: 'bambole', l: 'Bambolê' },
    { v: 'pranchas', l: 'Pranchas' }, { v: 'papeis', l: 'Papéis' },
    { v: 'pinceis', l: 'Pincéis' }, { v: 'jogos', l: 'Jogos' },
    { v: 'cola', l: 'Cola' }, { v: 'letras_ima', l: 'Letras com ímã' },
    { v: 'botoes', l: 'Botões' }, { v: 'barbantes', l: 'Barbantes' },
    { v: 'outros', l: 'Outros' },
  ],
};

export const AEE_DESEMPENHOS = [
  { v: 'com_ajuda', l: 'Com ajuda' },
  { v: 'nao_realizou', l: 'Não realizou' },
  { v: 'insuficiente', l: 'Insuficiente' },
  { v: 'sem_ajuda', l: 'Sem ajuda' },
  { v: 'satisfatoriamente', l: 'Satisfatoriamente' },
  { v: 'outros', l: 'Outros' },
];

export const PDI_TEMPO = [
  { v: '2x_semana', l: '2x/semana' },
  { v: '1x_semana', l: '1x/semana' },
  { v: '50min', l: '50 min' },
  { v: 'outros', l: 'Outros' },
];

export const PDI_COMPOSICAO = [
  { v: 'individual', l: 'Individual' },
  { v: 'grupal', l: 'Grupal' },
  { v: 'sala_aula', l: 'Em sala de aula' },
  { v: 'domicilio', l: 'Domicílio' },
  { v: 'hospitalar', l: 'Hospitalar' },
  { v: 'outros', l: 'Outros' },
];

export const PDI_PROFISSIONAIS = [
  { v: 'fono', l: 'Fonoaudiologia' },
  { v: 'psico', l: 'Psicologia' },
  { v: 'social', l: 'Assistência Social' },
  { v: 'medica', l: 'Área médica' },
  { v: 'outros', l: 'Outros' },
];

export const PDI_AREAS = [
  { v: 'cognitiva', l: 'Função Cognitiva e Metacognitiva' },
  { v: 'interacao_social', l: 'Interação Social' },
  { v: 'linguagem', l: 'Linguagem (Oral, Escrita e Expressiva)' },
  { v: 'motoras', l: 'Habilidades Motoras e Psicomotoras' },
  { v: 'avd', l: "Atividades de Vida Diária (AVD's)" },
  { v: 'leitora', l: 'Habilidade Leitora' },
  { v: 'matematica', l: 'Linguagem Matemática' },
  { v: 'artistica', l: 'Linguagem Artística' },
];

export const PDI_MATERIAIS = [
  { v: 'jogo_mico', l: 'Jogo do Mico' }, { v: 'quebra_cabeca', l: 'Quebra-cabeça' },
  { v: 'boliches', l: 'Boliches' }, { v: 'argila', l: 'Argila' },
  { v: 'tintas_pva', l: 'Tintas PVA' }, { v: 'micangas', l: 'Miçangas' },
  { v: 'tapetes', l: 'Tapetes' }, { v: 'barbantes', l: 'Barbantes' },
  { v: 'pincas', l: 'Pinças' }, { v: 'telas', l: 'Telas' },
  { v: 'colchonetes', l: 'Colchonetes' }, { v: 'tablet', l: 'Tablet' },
  { v: 'fitas', l: 'Fitas' }, { v: 'computadores', l: 'Computadores' },
  { v: 'portfolios', l: 'Portfólios' }, { v: 'brinquedos', l: 'Brinquedos educativos' },
  { v: 'cola', l: 'Cola' }, { v: 'almofadas', l: 'Almofadas' },
  { v: 'instrumentos', l: 'Instrumentos musicais' }, { v: 'engrossadores', l: 'Engrossadores' },
  { v: 'pistola_cola', l: 'Pistola de cola quente' }, { v: 'cordas', l: 'Cordas' },
  { v: 'carimbos', l: 'Carimbos' }, { v: 'gode', l: 'Godê' },
  { v: 'plastificadora', l: 'Plastificadora' }, { v: 'impressora', l: 'Impressora' },
  { v: 'notebook_touch', l: 'Notebook touch' }, { v: 'cadeira_adaptada', l: 'Cadeira adaptada' },
  { v: 'fio_nylon', l: 'Fio de nylon' }, { v: 'abacos', l: 'Ábacos' },
  { v: 'fantoches', l: 'Fantoches' }, { v: 'tesoura_adaptada', l: 'Tesoura adaptada' },
  { v: 'painel_sensorial', l: 'Painel sensorial' }, { v: 'papel_aluminio', l: 'Papel alumínio' },
  { v: 'datashow', l: 'Datashow' }, { v: 'microfone', l: 'Microfone' },
  { v: 'outros', l: 'Outros' },
];

export const PDI_ATIVIDADES_DIFERENCIADAS = [
  { v: 'comunicacao_alternativa', l: 'Comunicação alternativa' },
  { v: 'informatica_acessivel', l: 'Informática acessível' },
  { v: 'libras', l: 'LIBRAS' },
  { v: 'adequacao_material', l: 'Adequação de material' },
  { v: 'braille', l: 'Código Braille' },
  { v: 'reglete_soroban', l: 'Reglete/Soroban' },
  { v: 'outros', l: 'Outros' },
];

// ============================================================
// TABULAÇÃO — Diagnósticos Pedagógicos (Base / Desenho)
// Cores e rótulos seguem o padrão visual definido pela rede para os
// gráficos de Participação e Distribuição.
// ============================================================

export const TABULACAO_TIPO = { BASE: 'BASE', DESENHO: 'DESENHO' };

export const TABULACAO_STATUS = {
  RASCUNHO: 1,
  CONCLUIDO: 2,
  ENVIADO_SUPERVISAO: 3,
};

export const TABULACAO_NIVEIS_BASE = [
  { v: 'nao_computado',       l: 'Não Computado',       curto: 'N.C.',     cor: '#595959' },
  { v: 'ausente',             l: 'Ausente',             curto: 'Ausente',  cor: '#A5A5A5' },
  { v: 'indiferenciado',      l: 'Indiferenciado',      curto: 'Indif.',   cor: '#ED7D31' },
  { v: 'diferenciado',        l: 'Diferenciado',        curto: 'Difer.',   cor: '#BFBFBF' },
  { v: 'quantitativo',        l: 'Quantitativo',        curto: 'Quanti.',  cor: '#5B9BD5' },
  { v: 'qualitativo',         l: 'Qualitativo',         curto: 'Quali.',   cor: '#FFC000' },
  { v: 'silabico_alfabetico', l: 'Silábico Alfabético', curto: 'Sil.Alf.', cor: '#70AD47' },
  { v: 'alfabetico',          l: 'Alfabético',          curto: 'Alfa.',    cor: '#264478' },
];

export const TABULACAO_NIVEIS_DESENHO = [
  { v: 'nao_computado',        l: 'Não Computado',        curto: 'N.C.',       cor: '#595959' },
  { v: 'ausente',              l: 'Ausente',              curto: 'Ausen.',     cor: '#A5A5A5' },
  { v: 'garatuja_desordenada', l: 'Garatuja Desordenada', curto: 'Gar.Desor.', cor: '#ED7D31' },
  { v: 'garatuja_ordenada',    l: 'Garatuja Ordenada',    curto: 'Gar.Ord.',   cor: '#FFC000' },
  { v: 'garatuja_nominada',    l: 'Garatuja Nominada',    curto: 'Gar.Nom.',   cor: '#5B9BD5' },
  { v: 'pre_esquema',          l: 'Pré-Esquema',          curto: 'Pré-Esq.',   cor: '#70AD47' },
  { v: 'esquematica',          l: 'Esquemática',          curto: 'Esquem.',    cor: '#264478' },
];

export function tabulacaoNiveisPorTipo (tipo) {
  return tipo === TABULACAO_TIPO.DESENHO ? TABULACAO_NIVEIS_DESENHO : TABULACAO_NIVEIS_BASE;
}

export const TABULACAO_PARTICIPACAO_CORES = {
  presentes: '#4472C4',
  ausentes: '#ED7D31',
  nao_computados: '#A5A5A5',
};